/**
 * Created by dreamc_t on 2017/5/23.
 */
import './addCoinTip.scss';
import tmpl from './addCoinTip.ejs';
import Events from 'f.core.event';

class AddCoinTip {
    constructor(options) {
        this.options = options;
        this.init();
    }

    init() {
        this.initDom();
        this.initEvent();
    }

    initDom() {
        let _tmp = tmpl({
            text: this.options.point || 3,
        });
        this.el = $(_tmp);
        document.body.appendChild(this.el[0]);
    }

    initEvent() {
        this.el.fadeIn(500);
        this.timer = null;
        this.timer = setTimeout(() => {
            this.el.fadeOut('slow');
        }, 2000);
    }
}
Events.mixTo(AddCoinTip);

export default AddCoinTip;



// WEBPACK FOOTER //
// ./app/modules/addCoinTip/index.js